import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';

import useLinkProps from '../../../../hooks/use-link-props';
import FeaturedLink from '../../../ui/links/featured';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import saveUserCars from '../../../../services/user/save-cars';
import useSelectVehicle from '../../../modules/vehicle-picker/use-selected-vehicle';

type ChangeCarProps = {
  carInfo: TVehiclePreview['info'];
};

const ChangeCar = ({ carInfo }: ChangeCarProps) => {
  const { t } = useTranslation();
  const { locale = 'en' } = useRouter();
  const getLink = useLinkProps();
  const setUserVehicle = useSelectVehicle();

  if (!!carInfo?.version) {
    const link = getLink('categories-with-vehicle', {
      category: carInfo?.model?.slug,
    });

    return (
      <div className="max-lg:text-center text-base lg:text-xl">
        <span className='lg:text-xl"'>{t(`vehicle:if-prefer`)}</span>
        <Link {...link} legacyBehavior passHref>
          <FeaturedLink
            variant="blackBold"
            className="!text-[20px] max-lg:text-base"
            onClick={() => {
              setUserVehicle(carInfo?.model?.slug)
            }}
          >
            {t(`vehicle:remove-version`)}
          </FeaturedLink>
        </Link>
      </div>
    );
  } else {
    const link = getLink('versions', { model: carInfo?.model?.slug });

    return (
      <div className="max-lg:text-center text-base lg:text-xl">
        <span className='lg:text-xl"'>{t(`vehicle:if-prefer`)}</span>
        <Link {...link} legacyBehavior passHref>
          <FeaturedLink
            variant="blackBold"
            className="!text-[20px] max-lg:text-base"
          >
            {t(`vehicle:insert-version`, {
              vehicle: carInfo?.brand.name + ' ' + carInfo?.model?.name,
            })}
          </FeaturedLink>
        </Link>
      </div>
    );
  }
};

export default ChangeCar;
